import { render, staticRenderFns } from "./userContentRead.vue?vue&type=template&id=41d5a315&"
import script from "./userContentRead.vue?vue&type=script&lang=js&"
export * from "./userContentRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports